<template>
  <div class="bg-black w-full h-12 md:h-32 flex align-center justify-center text-white p-3 md:p-14">
    <p>@ 2021 Rad Reindeer LLC</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>